import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import TrashIcon from 'assets/TrashIcon';
import SearchBar from 'components/SearchBar';
import locales from 'locales';

const styles = {
  wrapper: {
    marginBottom: '10px',
  },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    margin: '0 10px',
  },
  infoTitle: {
    flex: '0 0 auto',
  },
  toolsWrapper: {
    display: 'flex',
  },
  searchBar: {
    width: '300px',
    height: '50px',
    backgroundColor: 'white'
  },
  trashButton: {
    width: '50px',
    height: '50px',
    border: '1px solid #E0E0E0',
    backgroundColor: '#E14E52',
    borderRadius: '10px',
    cursor: 'pointer',
  },
};

const MembersTableToolbar = (props) => {
  const {
    numSelected,
    handleSearch, searchString, removeMembers, user,
  } = props;

  const removeUsersOnHoverText = `${locales[user.language].removeUsers}`;

  return (
    <div style={styles.wrapper}>
      <h2 style={styles.infoTitle} />
      <div style={styles.toolsWrapper}>
        <div style={styles.searchBar}>
          <SearchBar wrapperStyles={styles.searchBar} searchString={searchString} handleSearch={handleSearch} id="members-search-input" user={user} />
        </div>
        {numSelected > 0 && (
          <div style={styles.actions}>
            <button type="button" title={removeUsersOnHoverText} aria-label="Remove Users" onClick={removeMembers} style={styles.trashButton}>
              <TrashIcon width="16" height="20" fill="#FFFFFF" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

MembersTableToolbar.propTypes = {
  user: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  searchString: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired,
  removeMembers: PropTypes.func.isRequired,
};

export default Radium(MembersTableToolbar);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/MembersTableToolbar.jsx